<template>
  <va-card>
    <div class="row col-12 d-flex justify--space-between">
      <h5 class="is-bold">{{ measurementTitle }}</h5>
      <font-awesome-icon
        icon="fa-solid fa-down-left-and-up-right-to-center"
        class="clickable card-icon"
        @click.prevent="$emit('collapse')"
      />
    </div>
      <div class="row col-12">
        <div class="col-3 col-md-3 col-sm-3 mt-5 p-0">
          <div class="h-100 d-flex flex-column">
            <div style="flex: 0 0 80%" class="d-flex justify--center align-items-center">
              <div class="d-flex flex-column">
                <div class="d-flex justify--center p-0" style="min-width: 72px">
                  <span :class="icon"/>
                </div>
                <div class="text-center mt-3">
                <span class="is-bold mt-3 text-center" v-if="data && data.length && data[0].isIndividualResult === true">
                  {{data[0].lastResults[0]}}
                </span>
                  <span class="is-bold mt-3 text-center" v-else-if="data && data.length && data[0].isIndividualResult === false && data[0].lastResults.length > 0">
                  {{data[0].lastResults[0]}}
                  <va-popover
                    placement="top">
                    <template #popover>
                      <ul style="margin: 0; padding-left: 1em;">
                        <li v-for="elem in data[0].lastResults">{{elem}}</li>
                      </ul>
                    </template>
                    <i class="fa fa-plus-circle"></i>
                  </va-popover>
                </span>
                  <span class="is-bold mt-3 text-center" v-else>
                  N/A
                </span>
                </div>
              </div>
            </div>
            <div class="text-center" style="flex: 0 0 10%">
              <label style="font-size: 12.5px"
                     :class="{'recent-update': hasBeenUpdatedRecently}">{{ $t('dashboard_new_evollu.titles.last_update') }}: {{ lastUpdate || "N/A" }} </label>
            </div>


          </div>

        </div>
        <div class="col-9 col-md-9 col-sm-9">
          <div>
            <va-tabs v-model="tabValue" style="border-width: 2px" :disabled="true">
              <va-tab
                v-for="tab in viewType"
                :key="tab"
              >
                {{ $t(`dashboard_new_evollu.parameters.titles.${tab}`)}}
              </va-tab>
            </va-tabs>
            <v-client-table
              v-if="tabValue === 0"
              id="dataTable"
              ref="dataTable"
              name="dataTable"
              :data="data"
              :columns="columns"
              :options="tableOptions"
              @row-click="handleShowProfileModal"
            >
              <span slot="created_at" slot-scope="{row}">
                {{row.created_at}}
              </span>
              <span slot="automatic" slot-scope="{row}">
                <va-popover
                  v-if="row.automatic !== null && row.automatic === true"
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.device')">
                  <i class="fa fa-tablet"/>
                </va-popover>
                <va-popover
                  v-else
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.manual')">
                  <i class="fa fa-pencil"/>
                </va-popover>
              </span>
              <span slot="measurement_type" slot-scope="{row}">
                {{$t(`dashboard_new_evollu.parameters.${row.measurementType}`)}}
              </span>
            </v-client-table>

            <div v-if="tabValue===1">
            </div>
          </div>
        </div>
      </div>
    <ProfileModal
      v-if="showProfileModal"
      :measurement="selectedMeasurement"
      :patientDetails="patientDetails"
      :measurementTitle="measurementTitle"
      @cancel="onCancelProfileModal">
    </ProfileModal>

  </va-card>
</template>

<script>
import { ClientTable } from 'vue-tables-2'
import Vue from "vue";
import HearingTest from "@/components/common/HearingTest";
import moment from "moment/moment";
import ProfileModal from "@/components/checkup_plus/patients/ParametersDetails/ProfileModal.vue";
Vue.use(ClientTable, {}, false, 'bootstrap4')
export default {
  components: {
    ProfileModal,
    HearingTest,
    ClientTable,
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    measurementTitle: {
      type: String,
      required: true
    },
    lastUpdate: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    patientDetails: {
      type: Object,
      required: false
    },
  },
  data: function () {
    return {
      tabValue: 0,
      viewType: ['table'],
      tableOptions: {
        sortable: [],
        filterable: false,
        headings: {
          created_at: this.$t('tables.columns.created_at'),
          notes: this.$t('dashboard_new_evollu.parameters.titles.notes'),
          actions: this.$t('tables.columns.actions'),
          automatic: this.$t('checkup_plus.person.measurements.automatic'),
          measurement_type: this.$t('checkup_plus.person.rules.rule_creation.measurement')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        perPage: 5,
        perPageValues: [5, 10, 15, 20, 30, 50, 100],
        pagination: {
          chunk: 5,
          nav: 'scroll'
        },
        columnsClasses: {
          actions: 'actions',
          automatic: 'actions'
        }
      },
      showProfileModal: false,
      selectedMeasurement: null
    }
  },
  created() {
    this.hearingTestData = {
      hl_left: this.data[0].hl_left,
      hl_right: this.data[0].hl_right,
      hl_result: this.data[0].hl_raw,
      result: this.data[0].result_graph_str
    }
  },
  computed: {
    hasBeenUpdatedRecently: function () {
      if (this.lastUpdate !== null) {
        return moment().diff(moment(this.lastUpdate), 'hours') < 12
      }
      return false
    },
  },
  methods: {
    handleShowProfileModal: function ({row}) {
      if (row.measurementSeries !== null && row.measurementSeries.length > 0) {
        this.selectedMeasurement = row
        this.showProfileModal = true
      } else {
        this.showToast(this.$t('dashboard_new_evollu.measurements.no_profile'), this.$store.state.errorToastOptions)
      }
    },
    onCancelProfileModal: function () {
      this.selectedMeasurement = null
      this.showProfileModal = false
    },
  }
}
</script>
<style scoped lang="scss">
.chart{
  canvas{
    width:1000px !important;
    height:600px !important;
  }
}

.chart-wrapper {
  width: 100%;
  height: 400px;
  margin-top: 1rem;
  margin-bottom: 0.4rem;
  margin-right: 7.5%;
}

.icon-last-measurement {
  height: 80%;
  display: flex;
  flex-direction: column;
}

.card-icon {
  color: $vue-green;
  font-size: 22px;
}
</style>
<style lang="scss">
.actions {
  text-align: center;
}
</style>
